$(document).ready(function() {
	if(!document.getElementById('modal_password_popup')) return false;
	
	// #### passModal : Commercial Laundry Manual Download Password popup scripts

	var passModal = {
		el: document.getElementById("modal_password_popup"),
		form: document.getElementById("passwordPopupForm"),
		submit: document.getElementById("passwordPopupSubmit"),
		init: function(){
			passModal.addEvent();
		},
		addEvent: function(){
			$(passModal.form).on({
				submit: function(e){
					e.preventDefault();
					// var param = $(this).serializeArray();
					var param = xssfilter($(this).serialize());
					var url = this.getAttribute('data-url');
					ajax.call(url, param, 'json', function(data){
						// 성공 여부에 따른 dim 해제?
						if(data.manualDownloadCert=="Y") {
							$('body').find('.modal-backdrop').remove();
							$('#modal_password_popup').modal('hide');
						} else {
							$('#modal_password_popup').find('.incorrect-password').show();
						}
					});
				}
			});
		}
	};
	passModal.init();
});